(function (app, ng) {

    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Transaction.Disclose",
            {
                url: "/{transactionId}/Disclose",
                component: "disclose",
                resolve: {
                    transaction: ["transactionApi", "$transition$", function (transactionApi, $transition$) {
                        return transactionApi.get($transition$.params().transactionId);
                    }],
                    disclosures: ["transactionApi", "transaction", "_", function (transactionApi, transaction, _) {
                        return transactionApi.getDisclosures(transaction.Id).then(function(response) {
                            return _.orderBy(response, ["Order"]);
                        });
                    }],
                    nextStage: ["transaction", function (transaction) {
                        return transaction.CapturePoints.length > 0
                            ? "Transaction.Capture." + transaction.CapturePoints[0]
                            : "Transaction.Determine.ProductChoice";
                    }]
                },
                onEnter: ["$state", "transaction", "transactionApi", "disclosures",
                    function ($state, transaction, transactionApi, disclosures) {
                        if (disclosures.length === 0)
                            $state.go("Transaction.Capture", {transactionId: transaction.Id}, { reload: true }); 


                        transaction.LastTransactionStage = "Disclose";
                        transactionApi.updateLastTransactionStage(transaction.Id, transaction);
                    }]
            });
    }]);

    app.component("disclose",
        {
            templateUrl: "/App/Transaction/Disclose/template.html",
            controller: discloseController,
            bindings: {
                disclosures: "<",
                transaction: "<",
                nextStage: "<"
            }
        });

    discloseController.$inject = ["$state", "$scope"];
    function discloseController($state, $scope) {
        $scope.$parent.$ctrl.getCurrentStage($state);
        var $ctrl = this;

        ng.extend($ctrl,
            {
                UI: { isClosing: false }
            });

        this.$onInit = function() {
            $ctrl.UI.SelectedDisclosure = $ctrl.disclosures[0];
        };
    }

})(window.app, window.angular);